import React from 'react';

/**
 * One quiet attribution line at the foot of the login column: the Grasp
 * wordmark (which already reads "Grasp" — no "Powered by" text needed),
 * copyright, and the build version. Legal links live in the Step 1 terms
 * checkbox the learner must accept, so they are not repeated here.
 */
function LoginFooter() {
  const version = process.env.REACT_APP_VERSION;
  const sha = process.env.REACT_APP_BUILD_SHA;

  return (
    <footer className="login-footer">
      <a
        className="login-footer-brand"
        href="https://www.arifu.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Grasp by Arifu"
      >
        <img
          className="login-footer-logo login-footer-logo--light"
          src="/brand/grasp-logo.svg"
          alt="Grasp"
        />
        <img
          className="login-footer-logo login-footer-logo--dark"
          src="/brand/grasp-logo-dark.svg"
          alt="Grasp"
        />
      </a>
      <span className="login-footer-meta">
        © {new Date().getFullYear()} Arifu
        {version ? ` · v${version}` : ''}
        {sha ? ` · ${sha.slice(0, 7)}` : ''}
      </span>
    </footer>
  );
}

export default LoginFooter;
